import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// ── White-label brand colour ──────────────────────────────────────────────────
// REACT_APP_BRAND_COLOR (6-digit hex, e.g. #2b4aad) is set per client in
// Railway. If present and valid, it overrides the accent variables before
// first render. Inline custom properties on <html> take precedence over BOTH
// the :root (light) and html.dark blocks in App.css, so one injection themes
// both modes. --accent-glow is deliberately NOT set here — it derives from
// --accent-rgb in App.css, keeping the different light/dark alpha values.
// If the variable is unset or malformed, nothing happens and the CSS defaults
// (SHIFTon red) apply — demo and any client without the var are unaffected.
const BRAND_COLOR = (process.env.REACT_APP_BRAND_COLOR || '').trim();
if (/^#[0-9a-f]{6}$/i.test(BRAND_COLOR)) {
  const r = parseInt(BRAND_COLOR.slice(1, 3), 16);
  const g = parseInt(BRAND_COLOR.slice(3, 5), 16);
  const b = parseInt(BRAND_COLOR.slice(5, 7), 16);
  const dim = [r, g, b].map(c => Math.round(c * 0.75)); // ~25% darker for hover/pressed
  const s = document.documentElement.style;
  s.setProperty('--accent', BRAND_COLOR);
  s.setProperty('--accent-rgb', `${r},${g},${b}`);
  s.setProperty('--accent-dim', `rgb(${dim.join(',')})`);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(reg => console.log('SW registered:', reg.scope))
      .catch(err => console.log('SW registration failed:', err));
  });
}
